module.exports = __webpack_public_path__ + "img/companyIntro32.6b7c4a00.png";